import { InvoiceRow, InvoiceStatus } from "@wingspanhq/wingspan-api-sdk";

/** Statuses in which the payee's accept / dispute review is still open. */
const PAYEE_REVIEW_STATUSES: InvoiceStatus[] = [
  InvoiceStatus.OPENED,
  InvoiceStatus.OVERDUE,
  InvoiceStatus.PENDING
];

type Params = {
  invoice: InvoiceRow;
  /** The session account, i.e. whoever is looking at the row. */
  accountId?: string;
};

/**
 * Whether this account may accept or dispute the invoice.
 *
 * Accept and dispute are payee-*review* actions: they only make sense on a
 * payable the client raised against this account, never on the account's own
 * outgoing receivables (PLA-3535). Both accounts have to be known — a plain
 * `accountId !== invoice.accountId` is also satisfied while the session is
 * unresolved or when the row carries no account, which would offer the review
 * actions on every row.
 *
 * Shared by the row menu and the bulk-actions toolbar, which sit on the same
 * table: gating only one of them leaves the same write reachable through the
 * other.
 *
 * Callers add the per-action `payeeReviewStatus` check themselves, since accept
 * and dispute exclude different terminal states.
 */
export const selectorIsInvoicePayeeReviewable = (params: Params): boolean => {
  const { invoice, accountId } = params;

  if (!accountId || !invoice.accountId || invoice.accountId === accountId) {
    return false;
  }

  return !!invoice.status && PAYEE_REVIEW_STATUSES.includes(invoice.status);
};
